// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"409":"c2242014","453":"d536a134"}[chunkId] + ".chunk.js";
};